import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

// Generic scroll reveal wrapper
export function Reveal({ children, delay = 0, y = 40, className = "", ...rest }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, ease: EASE, delay }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

// Masked line-by-line reveal for headings.
// `lines` is an array of strings (or arrays of {text, red}).
export function MaskedLines({ lines, className = "", lineClassName = "", delay = 0, stagger = 0.12, animate = true }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="line-mask">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "110%" }}
            {...(animate
              ? { animate: { y: 0 } }
              : { whileInView: { y: 0 }, viewport: { once: true } })}
            transition={{ duration: 0.9, ease: EASE, delay: delay + i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

// Numbered chapter reveal helper
export function FadeUp({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, ease: EASE, delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
